const couponTypes = [
  { value: 'Percents', label: '%' },
  { value: 'Value', label: '$' },
];

export default couponTypes;
